export type CustomDataFormValues = Record<string, string | number | string[] | undefined | null>;
export type CustomDatumPayload = { field_id: number; content: string };

/**
 * RHF の customData ネストオブジェクト（キー: field_id 文字列）を
 * API ペイロードの custom_data: [{field_id, content}] 配列に変換する。
 *
 * mode:
 * - 'create': 空値 (undefined/null/'') のフィールドは送らない（新規作成、既存データ無し）
 * - 'update': undefined/null は送らない（未変更=既存データ維持）、'' は送る（明示削除）
 */
export function buildCustomDataPayload(
  customData: CustomDataFormValues | undefined,
  mode: 'create' | 'update'
): CustomDatumPayload[] {
  return Object.entries(customData ?? {})
    .filter(([, content]) => {
      if (content === undefined || content === null) return false;
      if (Array.isArray(content)) {
        // 配列は trim + 空要素除外したうえで、create モードでは空配列を送らない
        const nonEmpty = content
          .map(String)
          .map((v) => v.trim())
          .filter((v) => v !== '');
        return mode === 'create' ? nonEmpty.length > 0 : true;
      }
      if (mode === 'create' && content === '') return false;
      return true;
    })
    .map(([fieldId, content]) => ({
      field_id: Number(fieldId),
      content: Array.isArray(content)
        ? content
            .map(String)
            .map((v) => v.trim())
            .filter((v) => v !== '')
            .join(',')
        : String(content),
    }));
}
